const BASE_PATH = process.env.BASE_PATH;
const ENV = process.env.ENV;
const HOME_URL = process.env.HOME_URL;
const WEB_USERNAME = process.env.WEB_USERNAME;
const WEB_PASS = process.env.WEB_PASS;
const ASSETS_URL = process.env.ASSETS_URL;
const us_states = {
	'AL': 'Alabama',
	'AK': 'Alaska',
	'AS': 'American Samoa',
	'AZ': 'Arizona',
	'AR': 'Arkansas',
	'CA': 'California',
	'CO': 'Colorado',
	'CT': 'Connecticut',
	'DE': 'Delaware',
	'DC': 'District of Columbia',
	'FM': 'Federated States of Micronesia',
	'FL': 'Florida',
	'GA': 'Georgia',
	'GU': 'Guam',
	'HI': 'Hawaii',
	'ID': 'Idaho',
	'IL': 'Illinois',
	'IN': 'Indiana',
	'IA': 'Iowa',
	'KS': 'Kansas',
	'KY': 'Kentucky',
	'LA': 'Louisiana',
	'ME': 'Maine',
	'MH': 'Marshall Islands',
	'MD': 'Maryland',
	'MA': 'Massachusetts',
	'MI': 'Michigan',
	'MN': 'Minnesota',
	'MS': 'Mississippi',
	'MO': 'Missouri',
	'MT': 'Montana',
	'NE': 'Nebraska',
	'NV': 'Nevada',
	'NH': 'New Hampshire',
	'NJ': 'New Jersey',
	'NM': 'New Mexico',
	'NY': 'New York',
	'NC': 'North Carolina',
	'ND': 'North Dakota',
	'MP': 'Northern Mariana Islands',
	'OH': 'Ohio',
	'OK': 'Oklahoma',
	'OR': 'Oregon',
	'PW': 'Palau',
	'PA': 'Pennsylvania',
	'PR': 'Puerto Rico',
	'RI': 'Rhode Island',
	'SC': 'South Carolina',
	'SD': 'South Dakota',
	'TN': 'Tennessee',
	'TX': 'Texas',
	'UT': 'Utah',
	'VT': 'Vermont',
	'VI': 'Virgin Islands',
	'VA': 'Virginia',
	'WA': 'Washington',
	'WV': 'West Virginia',
	'WI': 'Wisconsin',
	'WY': 'Wyoming',
	'ON': 'Ontario',
	'QC': 'Quebec',
	'NS': 'Nova Scotia',
	'NB': 'New Brunswick',
	'MB': 'Manitoba',
	'BC': 'British Columbia',
	'PE': 'Prince Edward Island',
	'SK': 'Saskatchewan',
	'AB': 'Alberta',
	'NL': 'Newfoundland and Labrador',
	'YT': 'Yukon',
	'NT': 'Northwest Territories',
	'NU': 'Nunavut',
}
export {
	BASE_PATH,
	ENV,
	HOME_URL,
	WEB_USERNAME,
	WEB_PASS,
	ASSETS_URL,
	us_states
};
